import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["dataRows", "errorFieldFilter"];

  connect() {
    // Apply any existing filters when controller connects
    this.applyCurrentFilters();
  }

  searchRows(event) {
    const searchValue = event.target.value.toLowerCase();

    // Search only applies to data rows view
    if (!searchValue) {
      // If search is empty, show all rows based on current filter
      this.applyCurrentFilters();
      return;
    }

    this.searchDataRowsTable(searchValue);
  }

  showAllRows() {
    const rows = this.dataRowsTarget.querySelectorAll("tr");
    rows.forEach((row) => row.classList.remove("hidden"));
  }

  filterByErrorField(event) {
    const errorField = event.target.value;

    // If no specific field is selected, just show all rows
    if (!errorField) {
      this.showAllRows();
      return;
    }

    // Get all rows in the table
    const rows = this.dataRowsTarget.querySelectorAll("tr");

    // Filter rows based on error field
    rows.forEach((row) => {
      // Use the data-error-fields attribute for filtering
      const errorFields = row.dataset.errorFields;

      if (!errorFields) {
        row.classList.add("hidden");
        return;
      }

      // Check if the error fields include the selected field
      const errorFieldsList = errorFields.split(",");

      if (errorFieldsList.includes(errorField)) {
        row.classList.remove("hidden");
      } else {
        row.classList.add("hidden");
      }
    });

    // If there's also an active search, apply that filter too
    const searchInput = document.querySelector("input[name='search']");
    if (searchInput && searchInput.value) {
      this.searchDataRowsTable(searchInput.value.toLowerCase());
    }
  }

  applyCurrentFilters() {
    // First apply error field filter if one is selected
    if (this.hasErrorFieldFilterTarget && this.errorFieldFilterTarget.value) {
      this.filterByErrorField({ target: this.errorFieldFilterTarget });
    } else {
      this.showAllRows();
    }

    // Then apply search filter if one is set
    const searchInput = document.querySelector("input[name='search']");
    if (searchInput && searchInput.value) {
      this.searchDataRowsTable(searchInput.value.toLowerCase());
    }
  }

  searchDataRowsTable(searchValue) {
    const rows = this.dataRowsTarget.querySelectorAll("tr:not(.hidden)");

    rows.forEach((row) => {
      // Get all text content from the row's cells
      const rowText = Array.from(row.querySelectorAll("td"))
        .map((cell) => cell.textContent.toLowerCase())
        .join(" ");

      // Show/hide based on search match
      if (rowText.includes(searchValue)) {
        row.classList.remove("hidden");
      } else {
        row.classList.add("hidden");
      }
    });
  }
}
